import React from 'react' // eslint-disable-line no-unused-vars

const EmptyPage = () =>

  <div className='row widget-mb-0-row'>
    <div className='col'>
      <div className='container'>
        <div>
          <div className='row'>
            <div className='col-12 col-xl-12'>
              <h3 className='mb-3'>
                <i className='sli-shield m-r-10' />Error : This is an Empty Page
              </h3>
              <p>Please click on the button below to go back to the homepage.</p>
            </div>
            <div className='col-xl-2 col-lg-4'>
              <a className='btn btn-primary m-r-10 btn-icon' href='/'>
                <i className='sli-action-undo' />Return to the Homepage
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

export default EmptyPage



// WEBPACK FOOTER //
// ./src/pages/EmptyPage.js